import { useAppConstantsContext } from '@/context/AppConstants';
import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { AutomobileOwnershipHistory } from '@/reports/types/vehicles';
import { Stack, Text } from '@/theme/index';
import {
  CardDetails,
  CardImage,
  CardTitleText,
  StyledDivider,
  StyledPill,
} from './components';

interface VehicleOwnershipHistoryCardProps {
  position: number;
  vehicleOwnershipHistory: AutomobileOwnershipHistory;
  key?: string;
}

export function VehicleOwnershipHistoryCard({
  position,
  vehicleOwnershipHistory,
}: VehicleOwnershipHistoryCardProps) {
  const {
    images: { ownershipHistoryImages },
  } = useAppConstantsContext();

  const isLease = vehicleOwnershipHistory.lease === 'L';

  return (
    <DataCard
      testId="vehicle-ownership-history-card"
      spacing={0}
      cardStyles={{ minHeight: '410px', mb: 0 }}
      boxStyles={{
        width: { md: 'calc(33% - 0.85rem)', sm: '100%' },
      }}
    >
      <Stack spacing={2} direction="column">
        <Stack spacing={1} direction="row" justifyContent="space-between">
          <Stack direction="row" alignContent="center">
            <CardImage
              src={ownershipHistoryImages?.imgCircleUser}
              alt="owner"
            />
            <Text fontSize="1rem" fontWeight="bold" ml={1} mt={0.5}>
              Owner {position}
            </Text>
          </Stack>
          {isLease && <StyledPill label="Lease" size="small" />}
        </Stack>
        {CardTitleText({ vehicleOwnershipHistory })}
      </Stack>
      <StyledDivider />
      {CardDetails({ vehicleOwnershipHistory })}
    </DataCard>
  );
}
